import MobileTitleBar from "components/MobileTitleBar"
import React, { Component } from "react"
import { Container, Image } from "semantic-ui-react"
import WordPressContainer from "WordPressContainer"
import shop from "shop/shop"
import Responsive from "react-responsive"
import { useLocation } from "react-router-dom"
import SliderHomePage from "../components/Slider/SilderHomePage"

export default class HomePageV2 extends Component {

    render() {
        return (
            <div>
                <WordPressContainer slug="startseite"/>
                {/*<SliderHomePage  props={this.props}/> */}
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/theme/lindtbShop/pages/HomePageV2.js